import React from "react";
import { Table } from "rsuite";
import { Tooltip, Whisper, Button } from "rsuite";

export const CustomTableHeaderCell = (props: any) => (
  <Whisper
    followCursor
    speaker={<Tooltip arrow={false}>{props.placement}</Tooltip>}
  >
    <Table.HeaderCell {...props} style={{ padding: 4 }} />
  </Whisper>
);
